import { Directive, Host, TemplateRef } from '@angular/core';
import { QueryState, WorkflowQueryDto } from '@interfaces/queries';

type Comment = (id: string, state?: QueryState)=>void;

export interface ActionsContext {
	$implicit: Comment;
	comment: Comment;
	query: WorkflowQueryDto;
	message: boolean;
}

@Directive({
	selector: '[appQueryEditActions]',
})
export class QueryEditActionsDirective {
	constructor(@Host() public readonly template: TemplateRef<ActionsContext>) { }
}
